module.exports = __webpack_public_path__ + "static/media/league-of-legends.e0b71acd.png";